import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-luki-banner',
  templateUrl: './luki-banner.component.html',
})
export class LukiBannerComponent {
  @Input( {required: true} ) visibleLukiBannerModal!: boolean

  @Output() optionEventEmit = new EventEmitter();
  @Output() onClose = new EventEmitter<boolean>();


  closeModal(){
    this.onClose.emit(false);
  }

}
